/* eslint-disable */
import React from "react";
import {TextField} from "mui-rff";

const TextFieldAdapter = ({input, inputOnBlur, ...other}: any) => {
    const inputProps = {
        ...input,
        onChange: (e: any) => {
            input.onChange(e);
            inputOnBlur && inputOnBlur(e);
        },
        ...other
    };

    return <TextField {...inputProps} />;
};

export default TextFieldAdapter;